<template>
    <div class="guide-article">
        <guideWelcome :article="guide.article" />
        <div class="img-copyright f7" v-if="guide.article.imageCopyright" v-html="guide.article.imageCopyright"></div>
        <div class="static-section">
            <div class="static-gs guide-article-two">
                <div class="static-section">
                    <guideAuthorInfo />
                    <guideNavigation />
                </div>
                <div class="static-section">
                    <guideArticleContent />
                    <cardSection data-nosnippet v-if="guide.marketOverviewInfo && guide.marketOverviewInfo.length" :data="guide.marketOverviewInfo" :title="`${glb.geo.city}, ${glb.geo.state} Market Overview`"></cardSection>
                    <div class="static-gs gs-sm-2 relative-spacing relArticle">
                        <div>
                            <div class="f4">Related Articles</div>
                            <guideArticleCard class="static-gs gs-sm-2 relative-spacing" theme="related" :articles="relatedArticleCards" />
                            <ul>
                                <li v-for="relatedArticle in relatedArticleLinks">
                                    <a class="link" :href="glb.appUrl + relatedArticle.url">{{ relatedArticle.title }}</a>
                                </li>
                            </ul>
                        </div>
                        <guideArticleListingSeo />
                    </div>
                    <div data-nosnippet v-if="path.city ? getShowList('url', 'city') : getShowList('location')">
                        <div class="gx-full">
                            <h2 class="f4">Nearby Homes for Sale</h2>
                        </div>
                        <mvtLazyload ref="lazyloadNearby" :async="true" data-role="propertycard">
                            <mvtNearby :type="path.city ? 'city' : 'location'" filterPath="/pagesize-10/" @completed="completed" carousalType="for_sale"></mvtNearby>
                        </mvtLazyload>
                    </div>
                    <template v-if="path.condo">
                            <div data-nosnippet v-if="getShowList('condos', 'city')">
                                <div class="gx-full">
                                    <h2 class="f4">Nearby Condos</h2>
                                </div>
                                <mvtLazyload ref="lazyloadNearbyCondos" :async="true" data-role="propertycard">
                                    <mvtNearby type="city" filterPath="/condos/pagesize-10/" @completed="completed" carousalType="condos"></mvtNearby>
                                </mvtLazyload>
                            </div>
                     </template>
                    <guideArticleNearBySeo />
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./theme-two.js"></script>

<style lang="scss">
@use './theme-two.scss' as *;
</style>
